<script setup lang="ts">
import { computed } from 'vue';

interface AppFoldableTransitionProps {
  height: number;
}

const props = defineProps<AppFoldableTransitionProps>();

const heightInPx = computed<string>(() => `${props.height}px`);
</script>

<template>
  <transition name="fold">
    <slot />
  </transition>
</template>

<style scoped lang="scss">
.fold-enter-from,
.fold-leave-to {
  height: 0;
  opacity: 0;
}

.fold-enter-active,
.fold-leave-active {
  transition: height var(--transition-time-short) ease,
    opacity var(--transition-time-short) ease;
}

.fold-enter-to,
.fold-leave-from {
  height: v-bind(heightInPx);
  opacity: 1;
}
</style>
